"use strict";

export default class ObjectDataLoader {

	constructor(object)
	{
		this.object = object;
	}

	get(path) 
	{
		let self = this;
		let pathArray = path.split(".");
		return pathArray.reduce((a, b) => {
				return a && b && a[b] ? a[b] : null;
			}, 
			self.object
		);
	}

	updateData(object)
	{
		this.object = object;
		return this;
	}

}